"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ClientMetricReportDirection_1 = require("../clientmetricreport/ClientMetricReportDirection");
var ClientMetricReportMediaType_1 = require("../clientmetricreport/ClientMetricReportMediaType");
var ContentShareConstants_1 = require("../contentsharecontroller/ContentShareConstants");
var LogLevel_1 = require("../logger/LogLevel");
var DefaultVideoStreamIdSet_1 = require("../videostreamidset/DefaultVideoStreamIdSet");
var TargetDisplaySize_1 = require("./TargetDisplaySize");
var VideoPreference_1 = require("./VideoPreference");
var VideoPreferences_1 = require("./VideoPreferences");
var VideoPriorityBasedPolicyConfig_1 = require("./VideoPriorityBasedPolicyConfig");
/** @internal */
var LinkMediaStats = function LinkMediaStats() {
  _classCallCheck(this, LinkMediaStats);
  this.bandwidthEstimateKbps = 0;
  this.usedBandwidthKbps = 0;
  this.packetsLost = 0;
  this.nackCount = 0;
  this.rttMs = 0;
};
var VideoPriorityBasedPolicy = /*#__PURE__*/function () {
  function VideoPriorityBasedPolicy(logger) {
    var videoPriorityBasedPolicyConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : VideoPriorityBasedPolicyConfig_1.default.Default;
    _classCallCheck(this, VideoPriorityBasedPolicy);
    this.logger = logger;
    this.videoPriorityBasedPolicyConfig = videoPriorityBasedPolicyConfig;
    this.shouldPauseTiles = true;
    this.observerQueue = new Set();
    this.pausedBwAttendeeIds = new Set();
    this.reset();
  }
  _createClass(VideoPriorityBasedPolicy, [{
    key: "reset",
    value: function reset() {
      this.optimalReceiveSet = new DefaultVideoStreamIdSet_1.default();
      this.optimalReceiveStreams = [];
      this.optimalNonPausedReceiveStreams = [];
      this.subscribedReceiveSet = new DefaultVideoStreamIdSet_1.default();
      this.subscribedReceiveStreams = [];
      this.videoPreferences = undefined;
      this.defaultVideoPreferences = undefined;
      this.shouldPauseTiles = true;
      this.pausedStreamIds = new DefaultVideoStreamIdSet_1.default();
      this.pausedBwAttendeeIds = new Set();
      this.videoPreferencesUpdated = false;
      this.logCount = 0;
      this.startupPeriod = true;
      this.usingPrevTargetRate = false;
      this.rateProbeState = "Not Probing" /* NotProbing */;
      this.firstEstimateTimestamp = 0;
      this.lastUpgradeRateKbps = 0;
      this.timeBeforeAllowSubscribeMs = VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS;
      this.lastProbeTimestamp = Date.now();
      this.timeBeforeAllowProbeMs = VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS;
      this.downlinkStats = new LinkMediaStats();
      this.prevDownlinkStats = new LinkMediaStats();
      this.probeFailed = false;
    }
  }, {
    key: "bindToTileController",
    value: function bindToTileController(tileController) {
      this.tileController = tileController;
      this.logger.info('tileController bound');
    } // This function allows setting preferences without the need to inherit from this class
    // which would require not using the internal keyword
  }, {
    key: "chooseRemoteVideoSources",
    value: function chooseRemoteVideoSources(preferences) {
      var _a;
      if ((_a = this.videoPreferences) === null || _a === void 0 ? void 0 : _a.equals(preferences)) {
        return;
      }
      this.videoPreferences = preferences === null || preferences === void 0 ? void 0 : preferences.clone();
      this.videoPreferencesUpdated = true;
      this.logger.info("bwe: setVideoPreferences bwe: new preferences: ".concat(JSON.stringify(preferences)));
      return;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      this.videoIndex = videoIndex;
      if (!this.videoPreferences) {
        this.updateDefaultVideoPreferences();
      }
    }
  }, {
    key: "updateDefaultVideoPreferences",
    value: function updateDefaultVideoPreferences() {
      var attendeeIds = new Set();
      var _iterator = _createForOfIteratorHelper(this.videoIndex.remoteStreamDescriptions()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var stream = _step.value;
          attendeeIds.add(stream.attendeeId);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var prefs = VideoPreferences_1.VideoPreferences.prepare();
      var numAttendees = attendeeIds.size;
      var targetDisplaySize = TargetDisplaySize_1.default.High;
      if (numAttendees > 8) {
        targetDisplaySize = TargetDisplaySize_1.default.Low;
      } else if (numAttendees > 4) {
        targetDisplaySize = TargetDisplaySize_1.default.Medium;
      }
      var _iterator2 = _createForOfIteratorHelper(attendeeIds),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var attendeeId = _step2.value;
          prefs.add(new VideoPreference_1.default(attendeeId, 1, targetDisplaySize));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.defaultVideoPreferences = prefs.build();
    }
  }, {
    key: "updateMetrics",
    value: function updateMetrics(clientMetricReport) {
      if (!this.videoIndex || this.videoIndex.allStreams().empty()) {
        return;
      }
      this.prevDownlinkStats = this.downlinkStats;
      this.downlinkStats = new LinkMediaStats();
      var metricReport = clientMetricReport.getObservableMetrics();
      // Currently we have different stats between different browsers.
      // availableReceiveBandwidth is the old legacy Google stat
      // availableIncomingBitrate is the standard stat but is not available in Firefox yet so only Safari for now.
      if (!isNaN(metricReport.availableIncomingBitrate)) {
        this.downlinkStats.bandwidthEstimateKbps = metricReport.availableIncomingBitrate / 1000;
      } else {
        this.downlinkStats.bandwidthEstimateKbps = metricReport.availableReceiveBandwidth / 1000;
      }
      for (var ssrcStr in clientMetricReport.streamMetricReports) {
        var ssrc = Number.parseInt(ssrcStr, 10);
        var metrics = clientMetricReport.streamMetricReports[ssrc];
        if (metrics.direction === ClientMetricReportDirection_1.default.DOWNSTREAM && metrics.mediaType === ClientMetricReportMediaType_1.default.VIDEO) {
          // Only use video stream metrics
          if (metrics.currentMetrics.hasOwnProperty('googNacksSent')) {
            this.downlinkStats.nackCount += clientMetricReport.countPerSecond('googNacksSent', ssrc);
          } else if (metrics.currentMetrics.hasOwnProperty('nackCount')) {
            this.downlinkStats.nackCount += clientMetricReport.countPerSecond('nackCount', ssrc);
          }
          if (metrics.currentMetrics.hasOwnProperty('packetsLost')) {
            this.downlinkStats.packetsLost += clientMetricReport.countPerSecond('packetsLost', ssrc);
          }
          if (metrics.currentMetrics.hasOwnProperty('bytesReceived')) {
            this.downlinkStats.usedBandwidthKbps += clientMetricReport.bitsPerSecond('bytesReceived', ssrc) / 1000;
          }
        }
      }
    }
  }, {
    key: "wantsResubscribe",
    value: function wantsResubscribe() {
      this.calculateOptimalReceiveSet();
      return !this.subscribedReceiveSet.equal(this.optimalReceiveSet);
    }
  }, {
    key: "chooseSubscriptions",
    value: function chooseSubscriptions() {
      if (!this.subscribedReceiveSet.equal(this.optimalReceiveSet)) {
        this.lastSubscribeTimestamp = Date.now();
      }
      this.subscribedReceiveSet = this.optimalReceiveSet.clone();
      this.subscribedReceiveStreams = this.optimalReceiveStreams.slice();
      return this.subscribedReceiveSet.clone();
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observerQueue.delete(observer);
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _iterator3 = _createForOfIteratorHelper(this.observerQueue),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var observer = _step3.value;
          observerFunc(observer);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "setVideoPriorityBasedPolicyConfigs",
    value: function setVideoPriorityBasedPolicyConfigs(config) {
      this.videoPriorityBasedPolicyConfig = config;
    }
  }, {
    key: "calculateOptimalReceiveStreams",
    value: function calculateOptimalReceiveStreams() {
      var _a;
      var chosenStreams = [];
      var remoteInfos = this.videoIndex.remoteStreamDescriptions();
      if (remoteInfos.length === 0 || ((_a = this.videoPreferences) === null || _a === void 0 ? void 0 : _a.isEmpty())) {
        this.optimalReceiveStreams = [];
        return;
      }
      var lastProbeState = this.rateProbeState;
      this.cleanBwPausedTiles(remoteInfos);
      this.handleAppPausedStreams(chosenStreams, remoteInfos);
      var sameStreamChoices = this.availStreamsSameAsLast(remoteInfos);
      var noMajorChange = !this.startupPeriod && sameStreamChoices;
      // If no major changes then don't allow subscribes for the allowed amount of time
      if (noMajorChange && Date.now() - this.lastSubscribeTimestamp < this.timeBeforeAllowSubscribeMs) {
        return;
      }
      // Sort streams by bitrate ascending.
      remoteInfos.sort(function (a, b) {
        if (a.maxBitrateKbps === b.maxBitrateKbps) {
          return a.streamId - b.streamId;
        }
        return a.maxBitrateKbps - b.maxBitrateKbps;
      });
      // Convert 0 avg bitrates to max and handle special cases
      var _iterator4 = _createForOfIteratorHelper(remoteInfos),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var info = _step4.value;
          if (info.avgBitrateKbps === 0 || info.avgBitrateKbps > info.maxBitrateKbps) {
            // Content can be a special case
            if (info.attendeeId.endsWith(ContentShareConstants_1.default.Modality) && info.maxBitrateKbps < 100) {
              info.maxBitrateKbps = info.avgBitrateKbps;
            } else {
              info.avgBitrateKbps = info.maxBitrateKbps;
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var rates = {
        targetDownlinkBitrate: 0,
        chosenTotalBitrate: 0,
        deltaToNextUpgrade: 0
      };
      rates.targetDownlinkBitrate = this.determineTargetRate();
      var numberOfParticipants = this.subscribedReceiveSet.size();
      var currentEstimated = this.downlinkStats.bandwidthEstimateKbps;
      // Use videoPriorityBasedPolicyConfig to add additional delays based on network conditions
      var dontAllowSubscribe = !this.videoPriorityBasedPolicyConfig.allowSubscribe(numberOfParticipants, currentEstimated);
      if (this.probeFailed) {
        // When probe failed, we set timeBeforeAllowSubscribeMs to 3x longer
        // Since we have passed the subscribe interval now, we will try to probe again
        this.probeFailed = false;
        // For the same reason above, reset time before allow subscribe to default
        this.timeBeforeAllowSubscribeMs = VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS;
        if (noMajorChange && dontAllowSubscribe) return;
      }
      var upgradeStream = this.priorityPolicy(rates, remoteInfos, chosenStreams);
      var subscriptionChoice = 0 /* NewOptimal */;
      // Look for probing or override opportunities
      if (!this.startupPeriod && sameStreamChoices) {
        if (this.rateProbeState === "Probing" /* Probing */) {
          subscriptionChoice = this.handleProbe(chosenStreams, rates.targetDownlinkBitrate);
        } else if (rates.deltaToNextUpgrade !== 0) {
          subscriptionChoice = this.maybeOverrideOrProbe(chosenStreams, rates, upgradeStream);
        }
      } else {
        // If there was a change in streams to choose from, then cancel any probing or upgrades
        this.setProbeState("Not Probing" /* NotProbing */);
        this.lastUpgradeRateKbps = 0;
      }
      this.prevRemoteInfos = remoteInfos;
      this.videoPreferencesUpdated = false;
      if (subscriptionChoice === 1 /* PreviousOptimal */) {
        this.logger.info("bwe: keepSameSubscriptions stats:".concat(JSON.stringify(this.downlinkStats)));
        this.prevTargetRateKbps = rates.targetDownlinkBitrate;
        return;
      }
      if (subscriptionChoice === 2 /* PreProbe */) {
        var subscribedRate = this.calculateSubscribeRate(this.preProbeNonPausedReceiveStreams);
        this.optimalReceiveStreams = this.preProbeReceiveStreams.slice();
        this.processBwPausedStreams(remoteInfos, this.preProbeNonPausedReceiveStreams);
        this.logger.info('bwe: Use Pre-Probe subscription subscribedRate:' + subscribedRate);
        return;
      }
      this.optimalNonPausedReceiveStreams = chosenStreams.slice();
      var lastNumberPaused = this.pausedBwAttendeeIds.size;
      this.processBwPausedStreams(remoteInfos, chosenStreams);
      if (this.logger.getLogLevel() <= LogLevel_1.LogLevel.INFO && (this.logCount % 15 === 0 || this.rateProbeState !== lastProbeState || this.optimalReceiveStreams.length !== chosenStreams.length || lastNumberPaused !== this.pausedBwAttendeeIds.size)) {
        this.logger.info(this.policyStateLogStr(remoteInfos, rates.targetDownlinkBitrate));
        this.logCount = 0;
      }
      this.logCount++;
      this.prevTargetRateKbps = rates.targetDownlinkBitrate;
      this.optimalReceiveStreams = chosenStreams.slice();
    }
  }, {
    key: "calculateOptimalReceiveSet",
    value: function calculateOptimalReceiveSet() {
      var streamSelectionSet = new DefaultVideoStreamIdSet_1.default();
      this.calculateOptimalReceiveStreams();
      var _iterator5 = _createForOfIteratorHelper(this.optimalReceiveStreams),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var stream = _step5.value;
          streamSelectionSet.add(stream.streamId);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      if (!this.optimalReceiveSet.equal(streamSelectionSet)) {
        var subscribedRate = this.calculateSubscribeRate(this.optimalReceiveStreams);
        this.logger.info("bwe: new streamSelection: ".concat(JSON.stringify(streamSelectionSet), " subscribedRate:").concat(subscribedRate));
      }
      this.optimalReceiveSet = streamSelectionSet;
    }
  }, {
    key: "determineTargetRate",
    value: function determineTargetRate() {
      var _this = this;
      var targetBitrate = 0;
      var now = Date.now();
      // Startup phase handling.  During this period the estimate can be 0 or
      // could still be slowly hunting for a steady state.  This startup ramp up
      // can cause a series of subscribes which can be distracting. During this
      // time just use our configured default value
      if (this.downlinkStats.bandwidthEstimateKbps !== 0) {
        if (this.firstEstimateTimestamp === 0) {
          this.firstEstimateTimestamp = now;
        }
        // handle startup state where estimator is still converging.
        if (this.startupPeriod) {
          // Drop out of startup period if
          // - estimate is above default
          // - get packet loss and have a valid estimate
          // - startup period has expired and rate is not still increasing
          if (this.downlinkStats.bandwidthEstimateKbps > VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS || this.downlinkStats.packetsLost > 0 || now - this.firstEstimateTimestamp > VideoPriorityBasedPolicy.STARTUP_PERIOD_MS && this.downlinkStats.bandwidthEstimateKbps <= this.prevDownlinkStats.bandwidthEstimateKbps) {
            this.startupPeriod = false;
            this.prevTargetRateKbps = this.downlinkStats.bandwidthEstimateKbps;
          }
        }
        // If we are in the startup period and we haven't detected any packet loss, then
        // keep it at the default to let the estimation get to a steady state
        if (this.startupPeriod) {
          targetBitrate = VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS;
        } else {
          // We rely on our target bitrate being above what we are receiving to mark a probe as complete,
          // however in browsers, the estimate can heavily lag behind the actual receive rate, especially when low.
          //
          // To mitigate this we override with the actual estimate plus some buffer if we aren't seeing packet loss.
          if (this.rateProbeState === "Probing" /* Probing */ && this.downlinkStats.usedBandwidthKbps > this.downlinkStats.bandwidthEstimateKbps && this.downlinkStats.packetsLost < VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD) {
            this.logger.info("bwe: In probe state, overriding estimate ".concat(this.downlinkStats.bandwidthEstimateKbps, " with actual receive bitrate ").concat(this.downlinkStats.usedBandwidthKbps));
            targetBitrate = this.downlinkStats.usedBandwidthKbps + VideoPriorityBasedPolicy.USED_BANDWIDTH_OVERRIDE_BUFFER_KBPS;
          } else {
            targetBitrate = this.downlinkStats.bandwidthEstimateKbps;
          }
        }
      } else {
        if (this.firstEstimateTimestamp === 0) {
          targetBitrate = VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS;
        } else {
          targetBitrate = this.prevTargetRateKbps;
        }
      }
      // Estimated downlink rate can follow actual bandwidth or fall for a short period of time
      // due to the absolute send time estimator incorrectly thinking that a delay in packets is
      // a precursor to packet loss.  We have seen too many false positives on this, so we
      // will ignore largish drops in the estimate if there is no packet loss
      if (!this.startupPeriod && (this.usingPrevTargetRate && this.downlinkStats.bandwidthEstimateKbps < this.prevTargetRateKbps || this.downlinkStats.bandwidthEstimateKbps < this.prevTargetRateKbps * (100 - VideoPriorityBasedPolicy.LARGE_RATE_CHANGE_TRIGGER_PERCENT) / 100 || this.downlinkStats.bandwidthEstimateKbps < this.downlinkStats.usedBandwidthKbps * VideoPriorityBasedPolicy.LARGE_RATE_CHANGE_TRIGGER_PERCENT / 100) && this.downlinkStats.packetsLost === 0) {
        // Set target to be the same as last
        this.logger.debug(function () {
          return 'bwe: ValidateRate: Using Previous rate ' + _this.prevTargetRateKbps;
        });
        this.usingPrevTargetRate = true;
        targetBitrate = this.prevTargetRateKbps;
      } else {
        this.usingPrevTargetRate = false;
      }
      return targetBitrate;
    }
  }, {
    key: "setProbeState",
    value: function setProbeState(newState) {
      if (this.rateProbeState === newState) {
        return false;
      }
      var now = Date.now();
      switch (newState) {
        case "Not Probing" /* NotProbing */:
          this.probePendingStartTimestamp = 0;
          break;
        case "Probe Pending" /* ProbePending */:
          if (this.lastProbeTimestamp === 0 || now - this.lastProbeTimestamp > VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS) {
            this.probePendingStartTimestamp = now;
          } else {
            // Too soon to do a probe again
            return false;
          }
          break;
        case "Probing" /* Probing */:
          if (now - this.probePendingStartTimestamp > this.timeBeforeAllowProbeMs) {
            this.lastProbeTimestamp = now;
            this.preProbeReceiveStreams = this.subscribedReceiveStreams.slice();
            this.preProbeNonPausedReceiveStreams = this.optimalNonPausedReceiveStreams;
            // Increase the time allowed until the next probe
            this.timeBeforeAllowProbeMs = Math.min(this.timeBeforeAllowProbeMs * 2, VideoPriorityBasedPolicy.MAX_HOLD_BEFORE_PROBE_MS);
          } else {
            // Too soon to do probe
            return false;
          }
          break;
      }
      this.logger.info('bwe: setProbeState to ' + newState + ' from ' + this.rateProbeState);
      this.rateProbeState = newState;
      return true;
    } // Upgrade the stream id from the appropriate group or add it if it wasn't already in the list.
    // Return the added amount of bandwidth
  }, {
    key: "upgradeToStream",
    value: function upgradeToStream(chosenStreams, upgradeStream) {
      for (var i = 0; i < chosenStreams.length; i++) {
        if (chosenStreams[i].groupId === upgradeStream.groupId) {
          var diffRate = upgradeStream.avgBitrateKbps - chosenStreams[i].avgBitrateKbps;
          this.logger.info('bwe: upgradeStream from ' + JSON.stringify(chosenStreams[i]) + ' to ' + upgradeStream);
          this.lastUpgradeRateKbps = diffRate;
          chosenStreams[i] = upgradeStream;
          return diffRate;
        }
      }
      // We are adding a stream and not upgrading.
      chosenStreams.push(upgradeStream);
      this.lastUpgradeRateKbps = upgradeStream.avgBitrateKbps;
      return this.lastUpgradeRateKbps;
    } // Do specific behavior while we are currently in probing state and metrics
    // indicate environment is still valid to do probing.
    // Return true if the caller should not change from the previous subscriptions.
  }, {
    key: "handleProbe",
    value: function handleProbe(chosenStreams, targetDownlinkBitrate) {
      // Don't allow probe to happen indefinitely
      if (Date.now() - this.lastProbeTimestamp > VideoPriorityBasedPolicy.MAX_ALLOWED_PROBE_TIME_MS) {
        this.logger.info("bwe: Canceling probe due to timeout");
        this.setProbeState("Not Probing" /* NotProbing */);
        return 0 /* NewOptimal */;
      }
      if (this.downlinkStats.packetsLost > 0) {
        this.logger.info("bwe: Probe encountering packets lost:".concat(this.downlinkStats.packetsLost));
        // See comment above `VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD`
        if (this.downlinkStats.packetsLost > VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD) {
          this.setProbeState("Not Probing" /* NotProbing */);
          this.logger.info("bwe: Canceling probe due to packets lost:".concat(this.downlinkStats.packetsLost));
          this.probeFailed = true;
          this.timeBeforeAllowSubscribeMs = Math.max(VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS, this.timeBeforeAllowSubscribeMs) * 3;
          // packet lost indicates bad network and thus slowing down subscribing by extend delay by 3 times
          return 2 /* PreProbe */;
        }
      }
      var subscribedRate = this.calculateSubscribeRate(this.optimalReceiveStreams);
      if (this.chosenStreamsSameAsLast(chosenStreams) || targetDownlinkBitrate > subscribedRate) {
        this.logger.info("bwe: Probe successful");
        // If target bitrate can sustain probe rate, then probe was successful.
        this.setProbeState("Not Probing" /* NotProbing */);
        // Reset the time allowed between probes since this was successful
        this.timeBeforeAllowProbeMs = VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS;
        return 0 /* NewOptimal */;
      }
      return 1 /* PreviousOptimal */;
    }
  }, {
    key: "maybeOverrideOrProbe",
    value: function maybeOverrideOrProbe(chosenStreams, rates, upgradeStream) {
      var sameSubscriptions = this.chosenStreamsSameAsLast(chosenStreams);
      var useLastSubscriptions = 0 /* NewOptimal */;
      // We want to minimize thrashing between between low res and high res of different
      // participants due to avg bitrate fluctuations. If there hasn't been much of a change in estimated bandwidth
      // and the number of streams and their max rates are the same, then reuse the previous subscription
      var triggerPercent = rates.targetDownlinkBitrate > VideoPriorityBasedPolicy.LOW_BITRATE_THRESHOLD_KBPS ? VideoPriorityBasedPolicy.TARGET_RATE_CHANGE_TRIGGER_PERCENT : VideoPriorityBasedPolicy.TARGET_RATE_CHANGE_TRIGGER_PERCENT * 2;
      var minTargetBitrateDelta = rates.targetDownlinkBitrate * triggerPercent / 100;
      this.targetRateBaselineForDeltaCheckKbps = this.targetRateBaselineForDeltaCheckKbps !== undefined ? this.targetRateBaselineForDeltaCheckKbps : this.prevTargetRateKbps;
      if (!sameSubscriptions && Math.abs(rates.targetDownlinkBitrate - this.targetRateBaselineForDeltaCheckKbps) < minTargetBitrateDelta) {
        this.logger.info('bwe: MaybeOverrideOrProbe: Reuse last decision based on delta rate. {' + JSON.stringify(this.subscribedReceiveSet) + "}");
        useLastSubscriptions = 1 /* PreviousOptimal */;
      } else {
        this.targetRateBaselineForDeltaCheckKbps = rates.targetDownlinkBitrate;
      }
      // If there has been packet loss, then reset to no probing state
      if (this.downlinkStats.packetsLost > this.prevDownlinkStats.packetsLost) {
        this.setProbeState("Not Probing" /* NotProbing */);
        this.lastUpgradeRateKbps = 0;
        return useLastSubscriptions;
      }
      if (sameSubscriptions || useLastSubscriptions === 1 /* PreviousOptimal */) {
        // If planned subscriptions are same as last, then either move to probe pending state
        // or move to probing state if enough time has passed.
        switch (this.rateProbeState) {
          case "Not Probing" /* NotProbing */:
            this.setProbeState("Probe Pending" /* ProbePending */);
            break;
          case "Probe Pending" /* ProbePending */:
            if (this.setProbeState("Probing" /* Probing */)) {
              this.upgradeToStream(chosenStreams, upgradeStream);
              useLastSubscriptions = 0 /* NewOptimal */;
            }
            break;
        }
      } else {
        this.setProbeState("Not Probing" /* NotProbing */);
      }
      return useLastSubscriptions;
    } // Utility function to find max rate of streams in current decision
  }, {
    key: "calculateSubscribeRate",
    value: function calculateSubscribeRate(streams) {
      var subscribeRate = 0;
      var _iterator6 = _createForOfIteratorHelper(streams),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var stream = _step6.value;
          if (!this.pausedStreamIds.contain(stream.streamId) && !this.pausedBwAttendeeIds.has(stream.attendeeId)) {
            subscribeRate += stream.maxBitrateKbps;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return subscribeRate;
    }
  }, {
    key: "handleAppPausedStreams",
    value: function handleAppPausedStreams(chosenStreams, remoteInfos) {
      if (!this.tileController) {
        this.logger.warn('tileController not found!');
        return;
      }
      this.pausedStreamIds = new DefaultVideoStreamIdSet_1.default();
      var remoteTiles = this.tileController.getAllRemoteVideoTiles();
      var _iterator7 = _createForOfIteratorHelper(remoteTiles),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var tile = _step7.value;
          var state = tile.state();
          if (state.paused && !this.pausedBwAttendeeIds.has(state.boundAttendeeId)) {
            var j = remoteInfos.length;
            while (j--) {
              if (remoteInfos[j].attendeeId === state.boundAttendeeId) {
                this.logger.info('bwe: removed paused attendee ' + state.boundAttendeeId + ' streamId: ' + remoteInfos[j].streamId);
                this.pausedStreamIds.add(remoteInfos[j].streamId);
                // Add the stream to the selection set to keep the tile around
                if (this.subscribedReceiveSet.contain(remoteInfos[j].streamId)) {
                  chosenStreams.push(remoteInfos[j]);
                }
                remoteInfos.splice(j, 1);
              }
            }
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "processBwPausedStreams",
    value: function processBwPausedStreams(remoteInfos, chosenStreams) {
      var _this2 = this;
      if (!this.tileController) {
        this.logger.warn('tileController not found!');
        return;
      }
      var preferences = this.getCurrentVideoPreferences();
      if (preferences && this.shouldPauseTiles) {
        var videoTiles = this.tileController.getAllVideoTiles();
        var _iterator8 = _createForOfIteratorHelper(preferences),
          _step8;
        try {
          var _loop = function _loop() {
            var preference = _step8.value;
            var videoTile = _this2.getVideoTileForAttendeeId(preference.attendeeId, videoTiles);
            var paused = (videoTile === null || videoTile === void 0 ? void 0 : videoTile.state().paused) || false;
            if (!chosenStreams.some(function (stream) {
              return stream.attendeeId === preference.attendeeId;
            })) {
              // We cannot rely on the existance of video tile to indicate that the source exists in the call
              // because tiles will not be added or removed until after a full renegotiation (i.e. it will
              // be behind the state provided by the index)
              var streamExists = remoteInfos.some(function (stream) {
                return stream.attendeeId === preference.attendeeId;
              });
              if (videoTile && streamExists) {
                var info = _this2.optimalReceiveStreams.find(function (stream) {
                  return stream.attendeeId === preference.attendeeId;
                });
                if (info !== undefined) {
                  if (!paused) {
                    _this2.logger.info("bwe: pausing streamId ".concat(info.streamId, " attendee ").concat(preference.attendeeId, " due to bandwidth"));
                    _this2.forEachObserver(function (observer) {
                      observer.tileWillBePausedByDownlinkPolicy(videoTile.id());
                    });
                    _this2.tileController.pauseVideoTile(videoTile.id());
                  }
                  chosenStreams.push(info);
                }
                _this2.pausedBwAttendeeIds.add(preference.attendeeId);
              } else if (streamExists) {
                // Create a tile for this participant if one doesn't already exist and mark it as paused
                // Don't include it in the chosen streams because we don't want to subscribe for it then have to pause it.
                var newTile = _this2.tileController.addVideoTile();
                newTile.bindVideoStream(preference.attendeeId, false, null, 0, 0, 0, null);
                _this2.forEachObserver(function (observer) {
                  observer.tileWillBePausedByDownlinkPolicy(newTile.id());
                });
                newTile.pause();
                _this2.logger.info("bwe: Created video tile ".concat(newTile.id(), " for bw paused attendee ").concat(preference.attendeeId));
                _this2.pausedBwAttendeeIds.add(preference.attendeeId);
              }
            } else if (paused && _this2.pausedBwAttendeeIds.has(preference.attendeeId)) {
              _this2.logger.info("bwe: unpausing attendee ".concat(preference.attendeeId, " due to bandwidth"));
              _this2.forEachObserver(function (observer) {
                observer.tileWillBeUnpausedByDownlinkPolicy(videoTile.id());
              });
              _this2.tileController.unpauseVideoTile(videoTile.id());
              _this2.pausedBwAttendeeIds.delete(preference.attendeeId);
            }
          };
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }
  }, {
    key: "cleanBwPausedTiles",
    value: function cleanBwPausedTiles(remoteInfos) {
      var _this3 = this;
      if (!this.tileController) {
        this.logger.warn('tileController not found!');
        return;
      }
      var tiles = this.tileController.getAllRemoteVideoTiles();
      var preferences = this.getCurrentVideoPreferences();
      var _iterator9 = _createForOfIteratorHelper(tiles),
        _step9;
      try {
        var _loop2 = function _loop2() {
          var tile = _step9.value;
          var state = tile.state();
          if (!state.boundVideoStream) {
            if (!remoteInfos.some(function (stream) {
              return stream.attendeeId === state.boundAttendeeId;
            })) {
              _this3.tileController.removeVideoTile(state.tileId);
              _this3.logger.info("bwe: Removed video tile ".concat(state.tileId, " for bw paused attendee ").concat(state.boundAttendeeId));
            } else if (preferences !== undefined && !preferences.some(function (pref) {
              return pref.attendeeId === state.boundAttendeeId;
            })) {
              _this3.tileController.removeVideoTile(state.tileId);
            }
          }
        };
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "priorityPolicy",
    value: function priorityPolicy(rates, remoteInfos, chosenStreams) {
      var _this4 = this;
      var upgradeStream;
      var videoPreferences = this.getCurrentVideoPreferences();
      var highestPriority = videoPreferences.highestPriority();
      var nextPriority;
      var priority = highestPriority;
      while (priority !== -1) {
        nextPriority = -1;
        var _iterator10 = _createForOfIteratorHelper(videoPreferences),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var preference = _step10.value;
            if (preference.priority === priority) {
              // First subscribe to at least low rate
              var _iterator12 = _createForOfIteratorHelper(remoteInfos),
                _step12;
              try {
                var _loop3 = function _loop3() {
                  var info = _step12.value;
                  if (info.attendeeId === preference.attendeeId) {
                    if (!chosenStreams.some(function (stream) {
                      return stream.groupId === info.groupId;
                    })) {
                      if (rates.chosenTotalBitrate + info.avgBitrateKbps <= rates.targetDownlinkBitrate) {
                        chosenStreams.push(info);
                        rates.chosenTotalBitrate += info.avgBitrateKbps;
                      } else if (rates.deltaToNextUpgrade === 0) {
                        // Keep track of step to next upgrade
                        rates.deltaToNextUpgrade = info.avgBitrateKbps;
                        upgradeStream = info;
                      }
                    }
                  }
                };
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  _loop3();
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }
            } else {
              if (preference.priority > priority) {
                nextPriority = preference.priority;
                break;
              }
            }
          }
          // Now try to upgrade all attendee's with this priority
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
        var _iterator11 = _createForOfIteratorHelper(videoPreferences),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var _preference = _step11.value;
            if (_preference.priority === priority) {
              var _iterator13 = _createForOfIteratorHelper(remoteInfos),
                _step13;
              try {
                var _loop4 = function _loop4() {
                  var info = _step13.value;
                  if (info.attendeeId === _preference.attendeeId) {
                    var index = chosenStreams.findIndex(function (stream) {
                      return stream.groupId === info.groupId && stream.maxBitrateKbps < info.maxBitrateKbps;
                    });
                    if (index !== -1) {
                      var increaseKbps = info.avgBitrateKbps - chosenStreams[index].avgBitrateKbps;
                      if (_this4.hasSimulcastStreams(remoteInfos, info.attendeeId, info.groupId) && _this4.canUpgrade(info.avgBitrateKbps, _preference.targetSizeToBitrateKbps(_preference.targetSize))) {
                        _this4.logger.info("bwe: attendee: ".concat(info.attendeeId, " group: ").concat(info.groupId, " has simulcast and can upgrade avgBitrate: ").concat(info.avgBitrateKbps, " target: ").concat(_preference.targetSizeToBitrateKbps(_preference.targetSize), " targetTotalBitrate: ").concat(rates.targetDownlinkBitrate));
                        if (rates.chosenTotalBitrate + increaseKbps <= rates.targetDownlinkBitrate) {
                          rates.chosenTotalBitrate += increaseKbps;
                          chosenStreams[index] = info;
                        } else if (rates.deltaToNextUpgrade === 0) {
                          // Keep track of step to next upgrade
                          rates.deltaToNextUpgrade = increaseKbps;
                          upgradeStream = info;
                        }
                      } else {
                        _this4.logger.info('bwe: cannot upgrade stream quality beyond target size');
                      }
                    }
                  }
                };
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  _loop4();
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
            } else {
              if (_preference.priority > priority) {
                break;
              }
            }
          }
          // If we haven't subscribed to the highest rate of the top priority videos then
          // do not subscribe to any other sources
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
        if (priority === highestPriority && rates.deltaToNextUpgrade !== 0) {
          break;
        }
        priority = nextPriority;
      }
      return upgradeStream;
    }
  }, {
    key: "getVideoTileForAttendeeId",
    value: function getVideoTileForAttendeeId(attendeeId, videoTiles) {
      var _iterator14 = _createForOfIteratorHelper(videoTiles),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var tile = _step14.value;
          var state = tile.state();
          if (state.boundAttendeeId === attendeeId) {
            return tile;
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      return null;
    }
  }, {
    key: "canUpgrade",
    value: function canUpgrade(bitrateKbp, targetBitrateKbp) {
      if (bitrateKbp <= targetBitrateKbp) {
        this.logger.info("bwe: canUpgrade: bitrateKbp: ".concat(bitrateKbp, " targetBitrateKbp: ").concat(targetBitrateKbp));
        return true;
      }
      this.logger.info("bwe: cannot Upgrade: bitrateKbp: ".concat(bitrateKbp, " targetBitrateKbp: ").concat(targetBitrateKbp));
      return false;
    }
  }, {
    key: "hasSimulcastStreams",
    value: function hasSimulcastStreams(remoteInfos, attendeeId, groupId) {
      var streamCount = 0;
      var _iterator15 = _createForOfIteratorHelper(remoteInfos),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var info = _step15.value;
          if (info.attendeeId === attendeeId && info.groupId === groupId) {
            streamCount++;
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      this.logger.info("bwe: attendeeId: ".concat(attendeeId, " groupId: ").concat(groupId, " hasSimulcastStreams: streamCount: ").concat(streamCount));
      return streamCount > 1;
    }
  }, {
    key: "availStreamsSameAsLast",
    value: function availStreamsSameAsLast(remoteInfos) {
      var _this5 = this;
      if (this.prevRemoteInfos === undefined || remoteInfos.length !== this.prevRemoteInfos.length || this.videoPreferencesUpdated === true) {
        return false;
      }
      var _iterator16 = _createForOfIteratorHelper(remoteInfos),
        _step16;
      try {
        var _loop5 = function _loop5() {
            var info = _step16.value;
            var infoMatch = _this5.prevRemoteInfos.find(function (prevInfo) {
              return prevInfo.groupId === info.groupId && prevInfo.streamId === info.streamId && prevInfo.maxBitrateKbps === info.maxBitrateKbps;
            });
            if (infoMatch === undefined) {
              return {
                v: false
              };
            }
          },
          _ret;
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          _ret = _loop5();
          if (_ret) return _ret.v;
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      return true;
    }
  }, {
    key: "chosenStreamsSameAsLast",
    value: function chosenStreamsSameAsLast(chosenStreams) {
      if (this.optimalNonPausedReceiveStreams.length !== chosenStreams.length) {
        return false;
      }
      var _iterator17 = _createForOfIteratorHelper(this.optimalNonPausedReceiveStreams),
        _step17;
      try {
        var _loop6 = function _loop6() {
            var lastStream = _step17.value;
            if (!chosenStreams.some(function (stream) {
              return stream.streamId === lastStream.streamId;
            })) {
              return {
                v: false
              };
            }
          },
          _ret2;
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          _ret2 = _loop6();
          if (_ret2) return _ret2.v;
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      return true;
    }
  }, {
    key: "policyStateLogStr",
    value: function policyStateLogStr(remoteInfos, targetDownlinkBitrate) {
      var subscribedRate = this.calculateSubscribeRate(this.optimalReceiveStreams);
      var optimalReceiveSet = {
        targetBitrate: targetDownlinkBitrate,
        subscribedRate: subscribedRate,
        probeState: this.rateProbeState,
        startupPeriod: this.startupPeriod
      };
      // Reduced remote info logging:
      var remoteInfoStr = "remoteInfos: [";
      var _iterator18 = _createForOfIteratorHelper(remoteInfos),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var info = _step18.value;
          remoteInfoStr += "{grpId:".concat(info.groupId, " strId:").concat(info.streamId, " maxBr:").concat(info.maxBitrateKbps, " avgBr:").concat(info.avgBitrateKbps, "}, ");
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      remoteInfoStr += "]";
      var logString = "bwe: optimalReceiveSet ".concat(JSON.stringify(optimalReceiveSet), "\n") + "bwe:   prev ".concat(JSON.stringify(this.prevDownlinkStats), "\n") + "bwe:   now  ".concat(JSON.stringify(this.downlinkStats), "\n") + "bwe:   ".concat(remoteInfoStr, "\n");
      if (this.pausedStreamIds.size() > 0 || this.pausedBwAttendeeIds.size > 0) {
        logString += "bwe:   paused: app stream ids ".concat(JSON.stringify(this.pausedStreamIds), "  bw attendees { ").concat(Array.from(this.pausedBwAttendeeIds).join(' '), " }\n");
      }
      if (this.videoPreferences) {
        logString += "bwe:   preferences: ".concat(JSON.stringify(this.videoPreferences));
      } else {
        logString += "bwe:   default preferences: ".concat(JSON.stringify(this.defaultVideoPreferences));
      }
      return logString;
    }
  }, {
    key: "getCurrentVideoPreferences",
    value: function getCurrentVideoPreferences() {
      return this.videoPreferences || this.defaultVideoPreferences;
    }
  }]);
  return VideoPriorityBasedPolicy;
}();
exports.default = VideoPriorityBasedPolicy;
VideoPriorityBasedPolicy.DEFAULT_BANDWIDTH_KBPS = 2800;
VideoPriorityBasedPolicy.STARTUP_PERIOD_MS = 6000;
VideoPriorityBasedPolicy.LARGE_RATE_CHANGE_TRIGGER_PERCENT = 20;
VideoPriorityBasedPolicy.TARGET_RATE_CHANGE_TRIGGER_PERCENT = 15;
VideoPriorityBasedPolicy.LOW_BITRATE_THRESHOLD_KBPS = 300;
VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_PROBE_MS = 5000;
VideoPriorityBasedPolicy.MIN_TIME_BETWEEN_SUBSCRIBE_MS = 2000;
// We apply exponentional backoff to probe attempts if they do not
// succeed, so we need to set a reasonable maximum.
VideoPriorityBasedPolicy.MAX_HOLD_BEFORE_PROBE_MS = 30000;
VideoPriorityBasedPolicy.MAX_ALLOWED_PROBE_TIME_MS = 60000;
// Occasionally we see that on unpause or upgrade we see a single packet lost
// or two, even in completely unconstrained scenarios. We should look into
// why this occurs on the backend, but for now we require a non-trivial
// amount of packets lost to fail the probe. These could also be from
// other senders given we don't yet use TWCC.
VideoPriorityBasedPolicy.SPURIOUS_PACKET_LOST_THRESHOLD = 2;
// See usage
VideoPriorityBasedPolicy.USED_BANDWIDTH_OVERRIDE_BUFFER_KBPS = 100;